<div id="sub-page-nav" [ngClass]="{'disabled': disabled}">
  <div class="mobile-navigation">
    <app-dropdown-list header="Navigation">
      @for (subPage of subPages; track subPage) {
        <app-dropdown-list-item
          name="{{subPage.title}}"
          (click)="togglePanel(subPage.id)">
        </app-dropdown-list-item>
      }
    </app-dropdown-list>
  </div>
  <div class="desktop-navigation">
    <div class="navigation">
      <span class="navigation__header">NAVIGATION</span>
      @for (subPage of subPages; track subPage) {
        <span
          id="sub-page-nav.{{subPage.id}}"
          class="navigation__tab"
          [ngClass]="{'navigation__tab--selected': subPage.selected}"
          [ngStyle]="{'font-style': subPage.form && subPage.form.dirty ? 'italic' : 'normal'}"
          (click)="togglePanel(subPage.id)">
          {{subPage.title}}
        </span>
      }
    </div>
  </div>
</div>
